import { NextPage } from 'next'
import { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { selectors } from '../redux'
import Router, { routes } from '../routes/Router'

const AccessToStoreGuard = (Page: NextPage<any>): FC<any> => {
  return function AccessToStoreGuard(props) {
    const isInit = useSelector(selectors.app.isInit)
    const hasAccessToStore = useSelector(selectors.auth.hasAccessToStore)

    useEffect(() => {
      if (!hasAccessToStore) {
        Router.pushRoute(routes.account)
      }
    }, [isInit, hasAccessToStore])

    if (!isInit || !hasAccessToStore) {
      return null
    }

    return <Page {...props} />
  }
}

export default AccessToStoreGuard
